import { type FC } from 'react';

import { useLoadRecentlyUsedTemplates } from 'src/services/templates/useLoadRecentlyUsedTemplates';

import { NewProjectWidget, type NewProjectWidgetProps } from './NewProjectWidget';
import { MainStoreContainer } from './store';

export const Container: FC<NewProjectWidgetProps> = (props) => {
  useLoadRecentlyUsedTemplates();

  return (
    <MainStoreContainer>
      <NewProjectWidget {...props} />
    </MainStoreContainer>
  );
};
